(function () {
  var BUSINESS_DAYS = 10;

  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay(); // 0 = Sunday, 6 = Saturday
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-US', {
      weekday: 'long',
      month  : 'long',
      day    : 'numeric',
    });
  }

  var estimatedDate = addBusinessDays(new Date(), BUSINESS_DAYS);
  var dateLabel     = 'Ready by ' + formatDate(estimatedDate);

  var busy = false;
  function applyEstimate() {
    if (busy) return;
    busy = true;

    // ── Product page: the pick_up_time line inside pickup-availability-preview ──
    document.querySelectorAll(
      'pickup-availability-preview .pickup-availability-info p.caption'
    ).forEach(function (el) {
      if (el.textContent.trim() !== dateLabel) el.textContent = dateLabel;
    });

    // ── Pickup drawer: availability.pick_up_time inside each list item ──
    document.querySelectorAll(
      '.pickup-availability-list__item .pickup-availability-preview'
    ).forEach(function (el) {
      // The element has format: "✓ Pick up available, usually ready in 5+ days"
      // Replace everything after the last comma with our date
      el.innerHTML = el.innerHTML.replace(
        /,\s*[^<,]+(<\/span>)?\s*$/,
        ', ' + dateLabel.replace('Ready by ', '').toLowerCase()
      );
    });

    busy = false;
  }

  // Run immediately, on DOMContentLoaded, and watch for async pickup renders
  applyEstimate();
  document.addEventListener('DOMContentLoaded', function () {
    applyEstimate();

    // Observe the pickup-availability custom element for async variant-change updates
    var pickupEl = document.querySelector('pickup-availability');
    if (pickupEl) {
      var observer = new MutationObserver(applyEstimate);
      observer.observe(pickupEl, { childList: true, subtree: true });
    }
  });
})();
